import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const Control = ({ selectProps, ...props }) => {
    if (components.Control) {
        const {
            innerProps: { dataTest },
        } = selectProps;

        return (
            <div data-test={dataTest}>
                <components.Control {...props} />
            </div>
        );
    }
    return null;
};

Control.propTypes = {
    selectProps: PropTypes.shape({
        innerProps: PropTypes.shape({
            dataTest: PropTypes.string.isRequired,
        }),
    }).isRequired,
};

export default Control;
